/* UGC video slider: phone scroll bar (TALA). The thumb's width is the visible share of the row,
   its position follows the row's scroll. Hidden by CSS on desktop, where the arrows are used. */
if (!customElements.get('ugcs-scrollbar')) {
  customElements.define(
    'ugcs-scrollbar',
    class UgcsScrollbar extends HTMLElement {
      connectedCallback() {
        const root = this.closest('.ugcs');
        this.track = root && root.querySelector('.ugcs__track');
        if (!this.track) return;
        this.update = this.update.bind(this);
        this.track.addEventListener('scroll', this.update, { passive: true });
        window.addEventListener('resize', this.update);
        this.update();
      }

      disconnectedCallback() {
        if (!this.track) return;
        this.track.removeEventListener('scroll', this.update);
        window.removeEventListener('resize', this.update);
      }

      update() {
        const barWidth = this.clientWidth;
        const { scrollWidth, clientWidth, scrollLeft } = this.track;
        if (!barWidth || !scrollWidth) return;
        const thumbWidth = Math.max(24, Math.min(barWidth, (barWidth * clientWidth) / scrollWidth));
        const maxScroll = scrollWidth - clientWidth;
        const progress = maxScroll > 0 ? Math.min(1, Math.max(0, scrollLeft / maxScroll)) : 0;
        this.style.setProperty('--ugcs-thumb-w', `${thumbWidth}px`);
        this.style.setProperty('--ugcs-thumb-x', `${(barWidth - thumbWidth) * progress}px`);
      }
    }
  );
}
